import React, {useEffect, useState} from "react"
import {useOutletContext, useLocation, Outlet} from "react-router-dom"
import api, {requestFailed} from "../Scripts/api"
import PostCard from "../Components/PostCard"
import Loading from "../Components/Loading"

function Guides() {

    const oc = useOutletContext().oc
    const viewingID = useOutletContext().viewingID
    const locarr = useLocation().pathname.split('/').filter((char) => char !== '')
    const accountLocation = locarr[locarr.length - 2]
    const [guides, setGuides] = useState()

    const getGuides = () => {
        api.get(`/api/getguides`, {
            params: {accountID: viewingID}
        }).then((response) => {
            if (response.data) setGuides(response.data)
        }).catch(requestFailed)
    }

    useEffect(() => {
        getGuides()
    }, [viewingID, accountLocation])

    return (
        <div id="guides">
            {locarr[1] != "profile" && <h2>Guides by {accountLocation.substring(1)}</h2>}
            <p id="resultcount">{guides ? (guides.length == 1 ? guides.length + " guide" : guides.length + " guides") : ''}</p>
            <div id="postgrid">
            {!guides && <Loading/>}
            {guides && guides.map(({title, text, tags, url, likes}) => (
                    <PostCard key={url} title={title} text={text} tags={tags} url={"post/" + url}/>
                ))}
            </div>
            {locarr[1] != "profile" && <Outlet context={{oc: oc}}/>}
        </div>
    )
}

export default Guides;
